import React from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-js';
import { BaseModal } from 'components/UI';
import { VehicleConnections } from 'components/Vehicles/VehiclesWizard';
import { ReservationConnections } from 'components/Reservations';
import { AccessDeviceConnections } from 'components/AccessDevice';

const ChangeBrokersModal = ({
  title,
  vehicle,
  reservation,
  accessDevice,
  source,
  open,
  handleClick,
}) => {
  return (
    <BaseModal
      size="lg"
      open={open}
      maxWidth={1160}
      loading={false}
      handleClick={handleClick}
      title={title || i18n.t('vehicle.edit_broker')}
    >
      {source === 'reservation' && (
        <ReservationConnections showLabel={false} reservation={reservation} />
      )}
      {source === 'vehicle' && <VehicleConnections showLabel={false} currentVehicle={vehicle} />}
      {source === 'access_device' && (
        <AccessDeviceConnections showLabel={false} accessDevice={accessDevice} />
      )}
    </BaseModal>
  );
};

ChangeBrokersModal.propTypes = {
  title: PropTypes.string,
  vehicle: PropTypes.object,
  reservation: PropTypes.object,
  accessDevice: PropTypes.object,
  open: PropTypes.bool.isRequired,
  handleClick: PropTypes.func.isRequired,
  source: PropTypes.oneOf(['reservation', 'vehicle', 'access_device']),
};

ChangeBrokersModal.defaultProps = {
  open: false,
  source: 'vehicle',
  handleClick: () => {},
};

export default ChangeBrokersModal;
